import { findStateIcon } from "@/assets/states/StateIcon";
import type { StateKeyT } from "@/types/database/diaries";
import { useStateDefinitionsQuery } from "../../../interface/api/selectStates";
import Cell from "./TableCell";

interface Props {
	diaryStatus: StateKeyT;
	diaryId: string;
}
const State = ({ diaryStatus, diaryId }: Props) => {
	const { data: stateDefinitions } = useStateDefinitionsQuery();
	const state = stateDefinitions?.find(
		(state) => state.state_key === diaryStatus,
	);
	return (
		<Cell
			diaryId={diaryId}
			className="flex justify-center items-center gap-x-1 w-fit [&_svg]:w-[35px] [&_svg]:h-[35px] font-medium"
		>
			{findStateIcon(state?.state_key)}
			<p className="w-fit text-nowrap">{state?.name}</p>
		</Cell>
	);
};

export default State;
